import { Col } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import hasPermission from '../../../../Shared/hasPermission';
import { useCallback } from 'react';

const PracticeName = ({ practiceName }) => {
    const dispatch = useDispatch();

    const openPracticeEditorScreen = useCallback(() => {
        dispatch(actions.pims.fetchAllPims());
        dispatch(actions.practice.getAllPracticeGroups());
        dispatch(actions.toggle.toggleIsEditingPractice(true));
    }, [dispatch]);

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canEdit = hasPermission(`EditPractices`, permissions);
    
    return (
        <Col sm="12">
            {/* TODO: figure out better way to do conditional media breakpoint styling */}
            <h2 className="py-2 pb-3 justify-content-between border-bottom border-light d-none d-md-flex">
                <ValidatedPracticeName practiceName={practiceName} />
                <OpenPracticeEditFormButton
                    canEdit={canEdit}
                    openPracticeEditorScreen={openPracticeEditorScreen}
                />
            </h2>
            <h3 className="py-2 pb-3 border-bottom border-light d-flex d-md-none justify-content-between">
                <ValidatedPracticeName practiceName={practiceName} />
                <OpenPracticeEditFormButton
                    canEdit={canEdit}
                    openPracticeEditorScreen={openPracticeEditorScreen}
                />
            </h3>
        </Col>
    );
};

const ValidatedPracticeName = ({ practiceName }) => (
    <span>{practiceName || `Unknown Practice`}</span>
);

const OpenPracticeEditFormButton = ({ canEdit, openPracticeEditorScreen }) => {
    return (
        <span title="Edit Practice Info" onClick={openPracticeEditorScreen}>
            {canEdit && (
                <span className="px-2 hover-child hoverable op-8">
                    <FontAwesomeIcon icon={faEdit} size="xs" />
                </span>
            )}
        </span>
    );
};

export default PracticeName;
